var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEliminatePaperLeft({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 363,
    height: 418,
    viewBox: "0 0 363 418",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M149.415 2.33569L206.483 -24.4614L263.546 -51.2584L320.609 -78.0554L327.333 -81.2115",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M151.566 7.15063L209.704 -17.2429L267.843 -41.6323L325.986 -66.0173L338.602 -71.3117",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M153.512 12.0566L212.624 -9.88219L271.735 -31.821L330.843 -53.7641L347.53 -59.9566",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M155.247 17.0337L215.224 -2.4162L275.206 -21.8661L335.183 -41.3117L354.373 -47.5383",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M156.769 22.0798L217.508 5.15742L278.248 -11.7693L338.989 -28.6917L359.172 -34.3154",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M158.076 27.1865L219.472 12.8172L280.863 -1.54776L342.259 -15.9214L361.817 -20.4973",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M159.164 32.3486L221.108 20.5581L283.048 8.76332L344.984 -3.0229L362.022 -6.26884",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M160.038 37.5488L222.419 28.3542L284.792 19.1639L347.169 9.97348L359.215 8.1987",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M160.693 42.7751L223.396 36.1978L286.099 29.6247L348.802 23.0431L352.32 22.6752",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M161.127 48.0308L224.053 44.0792L286.974 40.1277L339.494 36.8304",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M161.345 53.2947L224.374 51.9775L287.406 50.6603L320.601 49.9675",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M161.345 58.5637L224.374 59.8809L287.406 61.1981L301.085 61.4846",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M161.127 63.832L224.053 67.7836L286.759 71.718",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M160.693 69.0846L223.396 75.662L276.954 81.2771",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M160.038 74.3137L222.419 83.5041L270.102 90.5305",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M159.164 79.5104L221.108 91.3052L265.654 99.7856",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M158.076 84.6725L219.472 99.0418L263.709 109.391",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M156.769 89.7793L217.508 106.702L266.772 120.429",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M155.247 94.8251L215.224 114.279L275.206 133.725L282.23 136",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M153.512 99.8033L212.624 121.746L271.735 143.685L303.297 155.403",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M151.566 104.708L209.704 129.102L267.843 153.491L317.351 174.254",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M149.415 109.524L206.483 136.321L263.546 163.122L320.609 189.919L327.23 193.029",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M147.062 114.249L202.955 143.402L258.844 172.564L314.734 201.726L334.257 211.909",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M144.516 118.863L199.137 150.334L253.749 181.801L308.365 213.268L337.938 230.306",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M141.779 123.375L195.028 157.096L248.273 190.817L301.518 224.542L337.81 247.524",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M138.852 127.763L190.64 163.678L242.423 199.597L294.203 235.511L333.688 262.894",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M135.744 132.027L185.977 170.071L236.205 208.124L286.437 246.168L325.961 276.113",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M132.462 136.157L181.049 176.267L229.64 216.381L278.226 256.491L315.569 287.321",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M129.008 140.148L175.872 182.255L222.732 224.363L269.592 266.465L303.232 296.697",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M125.4 143.989L170.447 188.016L215.503 232.044L260.55 276.071L289.476 304.339",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M121.624 147.679L164.786 193.549L207.956 239.424L251.118 285.29L274.661 310.312",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M117.695 151.203L158.899 198.84L200.102 246.481L241.301 294.113L259.029 314.611",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M113.629 154.565L152.801 203.887L191.969 253.204L231.136 302.518L242.758 317.152",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M109.425 157.755L146.489 208.672L183.557 259.58L220.62 310.493L225.9 317.746",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M105.088 160.766L139.983 213.188L174.883 265.606L208.398 315.95",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M100.626 163.597L133.297 217.431L165.964 271.26L189.911 310.711",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M96.054 166.231L126.432 221.386L156.815 276.537L169.945 300.37",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3748 168.677L119.418 225.055L147.457 281.425L149.162 284.854",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5924 170.922L112.244 228.42L131.623 271.866",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M81.72 172.966L104.938 231.487L118.415 265.456",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7708 174.8L97.5117 234.236L107.535 262.958",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7434 176.426L89.969 236.674L97.8969 262.868",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6572 177.842L82.3371 238.796L89.052 264.891",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5098 179.035L74.6185 240.597L80.5663 268.506",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3203 180.015L66.8364 242.064L72.1589 273.475",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0925 180.779L58.9946 243.204L63.6184 279.722",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8384 181.323L51.118 244.022L54.8248 288.08",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M40.572 181.649L43.2118 244.51L45.6029 301.5",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2891 181.755V316.818",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6278 333.595L24.7289 307.371L27.3687 244.51L30.0086 181.648",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4465 351.15L14.1875 306.716L19.4628 244.021L24.7424 181.323",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M-4.26074 368.385L-4.21789 368.055L3.68449 305.63L11.5865 243.205L19.4886 180.78",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M-20.3394 384.173L-17.2884 366.152L-6.77199 304.112L3.74409 242.063L14.2602 180.014",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M-37.4927 397.657L-30.2589 363.697L-17.1502 302.148L-4.04147 240.596L9.07158 179.034",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M-55.5079 408.849L-43.119 360.707L-27.4391 299.753L-11.7549 238.795L3.92498 177.841",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEliminatePaperLeft);
export default __webpack_public_path__ + "static/media/eliminate-paper-left.a55524cb5184aa897792038f0f7fad31.svg";
export { ForwardRef as ReactComponent };